module.exports = __webpack_public_path__ + "static/media/MainPage_8.78239674.png";